/**
 * Logs raw Image Recognition / Deephealth JSON to the browser console (F12)
 * so missing mapped fields can be compared against the vendor payload.
 */
export function logImageRecognitionJson(
  source: 'InsuranceCardOCR' | 'PrescriptionOCR' | 'PatientIDOCR',
  payload: { imageRecognitionJson?: string | null } | null | undefined,
): void {
  const raw = payload?.imageRecognitionJson;
  if (!raw) {
    console.info(`[ImageRecognition:${source}] (no raw JSON on response)`, payload);
    return;
  }

  try {
    console.info(`[ImageRecognition:${source}]`, JSON.parse(raw));
  } catch {
    console.info(`[ImageRecognition:${source}]`, raw);
  }
}
